import { newsList } from "@/mocks/portal";

export default function LatestPreview() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-600 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-bubble-chart-line" />
              最新爆料
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              新料速递 · 深度解读
            </h2>
            <p className="mt-2 text-sm text-foreground-600">不止八卦，更有独家整理的幕后与趋势解读。</p>
          </div>
          <a
            href="/latest"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 sm:inline-flex"
          >
            更多新料 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {newsList.slice(0, 3).map((n) => (
            <article
              key={n.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-sm"
            >
              <a href="/latest" className="relative block h-44 overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-600">
                  {n.category}
                </span>
                {n.tag && (
                  <span className="absolute right-3 top-3 rounded bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
                    {n.tag}
                  </span>
                )}
              </a>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 line-clamp-2">
                  {n.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600 line-clamp-2">{n.excerpt}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-time-line" />{n.time}</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-line" />{n.reads} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}